<template>
<div class="chapter">
<div class="inner_page">
<h2 class="image"><a id="page_v"><img alt="image" src="images/f000v-01.jpg"/></a></h2><a id="page_v">
</a><p class="contents"><a id="page_v"></a><a class="nounder" href="#/xhtml/003">1. <em>Implosion!</em></a></p>
<p class="contents"><a class="nounder" href="#/xhtml/004">2. <em>Autopsy Report</em></a></p>
<p class="contents"><span class="nounder" href="#/xhtml/005" title="Link target outside of Sample">3. <em>Ghost Hunters</em></span></p>
<p class="contents"><span class="nounder" href="#/xhtml/006" title="Link target outside of Sample">4. <em>New Meat</em></span></p>
<p class="contents"><span class="nounder" href="#/xhtml/007" title="Link target outside of Sample">5. <em>Cold Spot</em></span></p>
<p class="contents"><span class="nounder" href="#/xhtml/008" title="Link target outside of Sample">6. <em>What Are You in For?</em></span></p>
<p class="contents"><span class="nounder" href="#/xhtml/009" title="Link target outside of Sample">7. <em>Killer Ghost</em></span></p>
<p class="contents"><span class="nounder" href="#/xhtml/010" title="Link target outside of Sample">8. <em>You Know I Did It</em></span></p>
<p class="contents"><span class="nounder" href="#/xhtml/011" title="Link target outside of Sample">9. <em>The Séance</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/012" title="Link target outside of Sample">10. <em>Think He Saw Us?</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/013" title="Link target outside of Sample">11. <em>Inside the Bag</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/014" title="Link target outside of Sample">12. <em>Fire?</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/015" title="Link target outside of Sample">13. <em>Call 911</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/016" title="Link target outside of Sample">14. <em>Let Me Out</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/017" title="Link target outside of Sample">15. <em>Somebody Murdered Me</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/018" title="Link target outside of Sample">16. <em>The Mist</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/019" title="Link target outside of Sample">17. <em>Liar!</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/020" title="Link target outside of Sample">18. <em>Fight or Flight</em></span></p>
<p class="contents1"><span class="nounder" href="#/xhtml/021" title="Link target outside of Sample">19. <em>Exploding Head</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?ba353694